<template>
  <v-container height="100%">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Edad</th>
            <th>Altura</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="patient in patients" :key="patient.id">
            <td>{{ patient.name }}</td>
            <td>{{ patient.age }} años</td>
            <td>{{ patient.height }} m</td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="orange"
                    @click="editPatient(patient)"
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-folder-clock-outline</v-icon>
                  </v-btn>
                </template>
                <span>Historia clínica</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="blue"
                    @click="registerMeasures(patient)"
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-ruler</v-icon>
                  </v-btn>
                </template>
                <span>Registrar medidas</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="cyan"
                    @click="showTracing(patient)"
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Seguimiento del paciente</span>
              </v-tooltip>

              <v-tooltip
                top
                v-if="
                  Object.keys(patient.dates).length &&
                  patient.dates[0].date == getDate() &&
                  patient.dates[0].status == 'Pendiente'
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="green"
                    @click="checkAssistance(patient)"
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Marcar asistencia</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="deep-orange darken-1"
                    @click="assignDate(patient)"
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-calendar</v-icon>
                  </v-btn>
                </template>
                <span>Asignar cita a paciente</span>
              </v-tooltip>

              <v-tooltip top v-if="patient.clinic_history">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="deep-orange darken-1"
                    @click="
                      showPdfRecommendation(
                        patient.clinic_history.recommendation
                      )
                    "
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-file-pdf</v-icon>
                  </v-btn>
                </template>
                <span>Visualizar recomendaciones</span>
              </v-tooltip>

              <v-tooltip top v-if="null === patient.clinic_history">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="mx-2"
                    color="red"
                    @click="remove(patient)"
                    fab
                    small
                    dark
                  >
                    <v-icon dark>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar paciente</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <ClinicHistory
      :openModal="modalEditPatient"
      @close-modal="closeClinicHistory"
      :patient="patient"
      v-if="modalEditPatient"
    />
    <Measures
      :openModal="modalRegisterMeasures"
      @close-modal="modalRegisterMeasures = false"
      :patient="patient"
      v-if="modalRegisterMeasures"
    />
    <Trace
      :openModal="modalShowTracing"
      @close-modal="modalShowTracing = false"
      :patient="patient"
      v-if="modalShowTracing"
      @refresh-trace="refreshTrace"
    />
    <DateAssignment
      :openModal="modalDateAssignment"
      @close-modal="modalDateAssignment = false"
      :patient="patient"
      v-if="modalDateAssignment"
    />
    <PDFRecommendation
      :openModal="modalPdfRecommendation"
      @close-modal="closePdfRecommendation"
      :url="pdfRecommendationPath"
      v-if="modalPdfRecommendation"
    />
  </v-container>
</template>
<script>
import ClinicHistory from "./ClinicHistory";
import Measures from "./Measures";
import Trace from "./Trace";
import DateAssignment from "./DateAssignment";
import PDFRecommendation from "./PDFRecommendation";
import Swal from "sweetalert2";

export default {
  name: "Table",
  components: {
    ClinicHistory,
    Measures,
    Trace,
    DateAssignment,
    PDFRecommendation,
  },
  data() {
    return {
      modalEditPatient: false,
      modalRegisterMeasures: false,
      modalShowTracing: false,
      modalDateAssignment: false,
      modalPdfRecommendation: false,
      patient: null,
      pdfRecommendationPath: "",
    };
  },
  props: ["patients"],
  methods: {
    editPatient(patient) {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/patients/" + patient.id
        );
        request
          .then(({ data }) => {
            this.patient = data;
            this.modalEditPatient = true;
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
    registerMeasures(patient) {
      this.modalRegisterMeasures = true;
      this.patient = { id: patient.id, height: patient.height };
    },
    showTracing(patient) {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/patients/" + patient.id
        );
        request
          .then(({ data }) => {
            this.patient = data;
            this.modalShowTracing = true;
          })
          .finally(this.closeLoader());
      }, 200);
    },
    assignDate(patient) {
      this.patient = { id: patient.id, name: patient.name };
      this.modalDateAssignment = true;
    },
    showPdfRecommendation(recommendation) {
      this.pdfRecommendationPath = `${
        this.$store.state.baseApiUrl
      }/files/catalogs/recommendations/${
        recommendation.name
      }.pdf?_=${Date.now()}`;
      this.modalPdfRecommendation = true;
    },
    remove(patient) {
      Swal.fire({
        title: "¿Está seguro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.openLoader();
          window.setTimeout(async () => {
            try {
              await this.deleteRequest(`catalogs/patients/${patient.id}`);
              this.showSuccessMessage("Paciente eliminado correctamente");
              this.$emit("search-patients");
            } catch (e) {
              this.showErrorMessage(e.message);
            } finally {
              this.closeLoader();
            }
          }, 200);
        }
      });
    },
    checkAssistance(patient) {
      this.openLoader();
      window.setTimeout(async () => {
        try {
          const { message } = await this.postRequest(
            `catalogs/patients/${patient.id}/assistance`
          );
          this.showSuccessMessage(message);
          this.$emit("search-patients");
        } catch (e) {
          this.showErrorMessage(e.message);
        } finally {
          this.closeLoader();
        }
      }, 200);
    },
    closeClinicHistory() {
      this.modalEditPatient = false;
      this.$emit("search-patients");
    },
    closePdfRecommendation() {
      this.modalPdfRecommendation = false;
      this.pdfRecommendationPath = "";
    },
    refreshTrace(){
      this.modalShowTracing = false;
      this.showTracing(this.patient);
    }
  },
};
</script>
